const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

module.exports.reportData = {
  info: {
    campaignName: 'Dragon City - HOUSEHOLD CHALLENGES vs HARRY',
    influencerName: 'Callux',
    reportDate: new Date('2018-01-03'),
    hasLogo: true,
  },
  youtubeViews: 749886,
  youtubeEngagements: 31617,
  supportingActivity: [
    {
      platform: 'twitter',
      url: 'https://twitter.com/Callux/status/944623870182600704',
      title: 'New video with harry going up soon....',
      views: 93466,
      engagements: 2229,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1514540587224-Screen_Shot_2017_12_27_at_21.51.46.png',
    },
    {
      platform: 'twitter',
      url: 'https://twitter.com/Callux/status/944638546765377537',
      title: 'NEW VIDEOOO - HOUSEHOLD FOOTBALL CHALLENGES vs HARRY',
      views: 69906,
      engagements: 1604,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1514540625482-Screen_Shot_2017_12_27_at_21.51.53.png',
    },
  ],
  heroData: {
    main: {
      title: 'HOUSEHOLD CHALLENGES vs HARRY',
      subTitle: 'Another EPICCC battle between me and Harry...',
      videoUrl: 'https://www.youtube.com/watch?v=lIIbHGye6to',
      views: 749886,
      engagements: 31617,
      watchTimeUKIre: 3324101,
      watchTimeTotal: 5700652,
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [91.8, 8.2],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [12.1, 36.3, 26.2, 9.3, 5.9, 0.8, 1.2],
          },
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [1.1, 3, 1.5, 1.4, 1, 0.1, 0.1],
          },
        ],
      },
      viewingData: [{
        name: 'United Kingdom',
        watchTime: 3121091,
        views: 402294,
      },
      {
        name: 'United States',
        watchTime: 639114,
        views: 83584,
      },
      {
        name: 'Australia',
        watchTime: 283892,
        views: 34873,
      },
      {
        name: 'Ireland',
        watchTime: 203010,
        views: 27637,
      },
      {
        name: 'Canada',
        watchTime: 118301,
        views: 15292,
      },
    ],
    },
    supportingData: {
      labels: [
        'twitter',
      ],
      datasets: [{
        data: [163366],
        backgroundColor: [
          dyzioPalette.blue,
        ],
        borderColor: [
          dyzioPalette.bgBlue,
        ],
        borderWidth: 1,
      }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/callux-dragon-city-2017.js